<template>
  <div class="sign_up">
    <van-nav-bar
      :title="
        tabIndex === 1
          ? $t('message.activity_upload_works.want_up')
          : $t('message.activity_upload_works.up_reg')
      "
      fixed
      placeholder
    />
    <div class="sign_up_form">
      <div class="sign_up_form_title" v-if="index == 2">
        <van-icon name="warning" style="margin-right: 4px" />
        {{ $t('message.activity_upload_works.up_once') }}
      </div>
      <div class="sign_up_form_btn">
        <div :class="tabIndex === 1 ? 'active' : ''" @click="tabClick(1)">
          {{ $t('message.activity_upload_works.sign_up') }}
        </div>
        <div :class="tabIndex === 2 ? 'active' : ''" @click="tabClick(2)">
          {{ $t('message.activity_upload_works.agent') }}
        </div>
      </div>
    </div>
    <div v-show="tabIndex === 1">
      <div class="dai">
        <div class="add_sing_up_btn">
          <van-button type="info" icon="plus" @click="daiAddClickSignUp(1)">
            {{ $t('message.activity_upload_works.New_registration') }}</van-button
          >
        </div>
        <div class="dai_list">
          <div class="dai_list_ul" v-if="myselfShow">
            <div class="dai_list_ul_li" v-for="(item, index) in queryInfo" :key="index">
              <div class="dai_list_ul_li_left">
                <div class="dai_list_ul_li_left_title">
                  {{ item.signUpName }}
                  <span>{{ item.tranches }}</span>
                </div>
                <p>{{ item.signUpSchool }}</p>
              </div>
              <div class="dai_list_ul_li_right">
                <button v-if="!item.isSubmitWork" @click="worksTou(item)">作品上传</button>
                <button class="dai_list_ul_li_right_no" v-else>已上传</button>
              </div>
            </div>
          </div>
          <div class="dai_list_no" v-else>
            <img src="../../../../static/image/no_sign_up.png" alt="" />
            <span>{{ $t('message.activity_upload_works.no_add') }}</span>
          </div>
        </div>
        <div class="dai_back">
          <van-button
            @click="backUpActivity"
            type="default"
            icon-color="#3562FF"
            class="div_btn_new_btn"
            icon="share"
            round
            >{{ $t('message.activity_upload_works.activity_home') }}</van-button
          >
        </div>
      </div>
      <!-- <div v-if="myselfShow">
        <div class="form">
          <van-form ref="form" class="upload_works_flex" label-width="100%">
            <van-field
              :label="$t('message.activity_upload_works.work_name') + '*'"
              v-model="queryInfo.signUpName"
              :placeholder="$t('message.activity_upload_works.come_name')"
              :rules="[{ required: true, message: $t('message.activity_upload_works.come_name') }]"
            >
            </van-field>

            <van-field
              :label="$t('message.activity_upload_works.idnumber')"
              v-if="
                (activityData.notIdCard && index === 4) || (index === 6 && activityData.notIdCard)
              "
              v-model="queryInfo.idCard"
              :placeholder="$t('message.activity_upload_works.true_id')"
              :rules="IDCard"
            >
            </van-field>
            <van-field
              :label="$t('message.activity_upload_works.school')"
              v-if="activityData.showSchool"
              v-model="queryInfo.signUpSchool"
              :placeholder="$t('message.activity_upload_works.please_school')"
              :rules="[
                { required: true, message: $t('message.activity_upload_works.pleadeenter') }
              ]"
            >
            </van-field>
            <div>
              <VuePhoneNumberInput
                v-if="activityData.showPhone"
                v-model="phone"
                @update="validate"
                :translations="translations"
                class="phoneNumber"
                :preferred-countries="['CN', 'US', 'CA', 'TH', 'KH', 'PT', 'MY', 'JP']"
              />
            </div>
            <div style="padding: 0 16px; font-size: 14px; color: red" v-if="empty">
              {{ $t('message.activity_upload_works.phone_null') }}
            </div>
            <van-field
              v-if="activityData.displayGroup"
              name="radio"
              :label="$t('message.activity_upload_works.group') + '*'"
              :rules="[
                { required: true, message: $t('message.activity_upload_works.pleasegroup') }
              ]"
            >
              <template #input>
                <van-radio-group v-model="queryInfo.tranches" direction="horizontal">
                  <van-radio
                    style="width: 100%; margin-bottom: 10px"
                    v-for="(item, index) in codeListZu"
                    :key="index"
                    :name="item.codeName"
                    >{{ item.codeName }}</van-radio
                  >
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              readonly
              clickable
              name="picker"
              :value="queryInfo.competitionArea"
              :label="$t('message.activity_upload_works.region') + '*'"
              :rules="[
                { required: true, message: $t('message.activity_upload_works.select_region') }
              ]"
              :placeholder="$t('message.activity_upload_works.click_region')"
              @click="showPicker = true"
            />
            <div style="transform: translate(40px, -66px); font-size: 10px; color: #999">
                  {{ $t('message.activity_upload_works.competition_area') }}
            </div>
            <van-popup v-model="showPicker" position="bottom">
              <van-picker
                show-toolbar
                :columns="SaiquList"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>
          </van-form>
        </div>
        <div class="div">
          <van-checkbox
            style="margin-top: 12px"
            icon-size="16px"
            v-if="
              (activityData.notIdCard && index === 4) || (index === 6 && activityData.notIdCard)
            "
            v-model="checkedAggesID"
            ><div class="aggess">
              {{ $t('message.activity_upload_works.real_id') }}
            </div></van-checkbox
          >
        </div>
      </div> -->

      <!-- <div class="myself" v-else>{{ $t('message.activity_upload_works.suc_select') }}</div> -->
      <!-- <div class="div_btn" v-if="!btnShow">
        <button class="div_btn_sign_up" @click="signUpClick">
          {{ $t('message.activity_upload_works.real_to_name') }}
        </button>
      </div> -->
      <!-- <div class="div_btn_new" v-else>
        <van-button
          type="info"
          class="div_btn_new_btn"
          icon="todo-list"
          round
          v-if="!queryInfo.isSubmitWork"
          @click="worksTou(queryInfo)"
          >{{ $t('message.activity_upload_works.mision_works') }}</van-button
        >
        <van-button
          class="div_btn_new_btn color_btn"
          icon="todo-list"
          round
          v-else
          @click="worksClickNo"
          >{{ $t('message.activity_upload_works.mision_works') }}</van-button
        >
        <van-button
          @click="backUpActivity"
          type="default"
          icon-color="#3562FF"
          class="div_btn_new_btn colorfont"
          icon="share"
          round
          >{{ $t('message.activity_upload_works.activity_home') }}</van-button
        >
      </div> -->
    </div>
    <div v-show="tabIndex === 2">
      <div class="dai">
        <div class="add_sing_up_btn">
          <van-button type="info" icon="plus" @click="daiAddClickSignUp(2)">新增报名</van-button>
        </div>
        <div class="dai_list">
          <div class="dai_list_ul" v-if="listShow">
            <div class="dai_list_ul_li" v-for="(item, index) in daiListUser" :key="index">
              <div class="dai_list_ul_li_left">
                <div class="dai_list_ul_li_left_title">
                  {{ item.signUpName }}
                  <span>{{ item.tranches }}</span>
                </div>
                <p>{{ item.signUpSchool }}</p>
              </div>
              <div class="dai_list_ul_li_right">
                <button v-if="!item.isSubmitWork" @click="worksTou(item)">作品上传</button>
                <button class="dai_list_ul_li_right_no" v-else>已上传</button>
              </div>
            </div>
          </div>
          <div class="dai_list_no" v-else>
            <img src="../../../../static/image/no_sign_up.png" alt="" />
            <span>{{ $t('message.activity_upload_works.no_add') }}</span>
          </div>
        </div>
        <div class="dai_back">
          <van-button
            @click="backUpActivity"
            type="default"
            icon-color="#3562FF"
            class="div_btn_new_btn"
            icon="share"
            round
            >{{ $t('message.activity_upload_works.activity_home') }}</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const defaultQueryInfo = Object.freeze({
  activityId: 0,
  competitionArea: '',
  isSubmitWork: false,
  filmingLocation: '',
  idCard: '',
  isSignUp: 1,
  isWhether: 0,
  pictureDescription: '',
  pictureKeywords: '',
  scienceType: '',
  signUpName: '',
  signUpPhone: '',
  signUpSchool: '',
  tag: '',
  theme: '',
  tranches: '',
  userId: 0,
  workDescribe: '',
  workTitle: '',
  organizationId: sessionStorage.getItem('organizationId') || 0,
  worksType: 0
})
import { addSignUp, isSignUp, getSaiqu, getDetailActivity, daiWorksList } from '@/api/activity'
import { codeList } from '@/api/common'
import { Toast } from 'vant'
// import VuePhoneNumberInput from 'vue-phone-number-input'
// import 'vue-phone-number-input/dist/vue-phone-number-input.css'
export default {
  name: 'SignUp',
  data() {
    return {
      myselfShow: false,
      listShow: false,
      checkedAggesID: true,
      btnShow: false,
      telRules: [
        {
          required: true,
          message: this.$t('message.activity_upload_works.phone_null'),
          trigger: 'onBlur'
        },
        {
          // 自定义校验规则
          validator: (value) => {
            return /0?(13|14|15|17|18|19)[0-9]{9}/.test(value)
          },
          message: this.$t('message.activity_upload_works.phone_rules'),
          trigger: 'onBlur'
        }
      ],
      showPicker: false,
      tabIndex: 1,
      IDCard: [
        {
          required: true,
          message: this.$t('message.activity_upload_works.Id_null'),
          trigger: 'onBlur'
        },
        {
          //自定义校验规则
          validator: (value) => {
            return /(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value)
          },
          message: this.$t('message.activity_upload_works.true_id'),
          trigger: 'onBlur'
        }
      ],
      activityData: {},
      codeListZu: [],
      SaiquList: [],
      daiListUser: [],
      queryInfo: { ...defaultQueryInfo },
      phone: '',
      empty: false,
      translations: {
        // countrySelectorLabel: '中国',
        // countrySelectorError: '请选择国家',
        // phoneNumberLabel: '手机号码',
        // example: '示例 :'
      }
    }
  },
  components: {
    // VuePhoneNumberInput
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    index() {
      return this.$route.query.index * 1
    },
    isWhether() {
      return this.$route.query.isWhether * 1
    },
    tab() {
      return this.$route.query.tab * 1
    },
    divisionName() {
      return this.$route.query.divisionName
    },
    organizationId(){
      return this.$route.query.organizationId
    }
  },
  created() {
    if (this.$route.query.lang) {
      if (this.$route.query.lang == 'zhcn') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', false)
      }
      if (this.$route.query.lang == 'en') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', true)
      }
    }
    if (this.tab) {
      this.tabIndex = this.tab
    }
    if (sessionStorage.getItem('lang') == 'zhcn') {
      this.translations = {
        countrySelectorLabel: '国家',
        phoneNumberLabel: '手机号码'
      }
    } else {
      this.translations = {}
    }
    this.queryInfo.activityId = this.id
    this.queryInfo.worksType = this.index
    this.queryInfo.isWhether = this.isWhether
    // this.getListShow()
    // this.getActivityData()
    this.loginSignUp()
    // this.getCodeAllZu()
    this.getDaiListAll()
    if (sessionStorage.getItem('tabIndex')) {
      this.tabIndex = sessionStorage.getItem('tabIndex') * 1
    }
  },
  methods: {
    //已投稿点击
    worksClickNo() {
      Toast.success(this.$t('message.activity_upload_works.under_unview'))
    },
    //作品投稿
    worksTou(row) {
      console.log(row)
      this.$router.push({
        name: 'signUpUploadWorks',
        query: { id: this.id, index: this.index, isWhether: this.isWhether, userMyId: row.id }
      })
    },
    //代报名新增报名
    daiAddClickSignUp(isSignUp) {
      // 存tab栏切换状态
      sessionStorage.setItem('tabIndex', this.tabIndex)
      this.$router.push({
        name: 'DaiSignUp',
        query: {
          id: this.id,
          index: this.index,
          isWhether: this.isWhether,
          isSignUp: isSignUp,
          divisionName: this.divisionName,
          organizationId:this.organizationId
        }
      })
    },
    //查询代报名的作品
    async getDaiListAll() {
      const query = {
        activityId: this.id,
        worksType: this.index
      }
      const { data: res } = await daiWorksList(query)
      if (res.resultCode === 200) {
        if (res.data.length > 0) {
          this.daiListUser = res.data
          this.listShow = true
        } else {
          this.listShow = false
        }
      }
    },
    //本人报名和代报名切换
    tabClick(index) {
      this.tabIndex = index
      sessionStorage.setItem('tabIndex', index)
    },
    //返回活动首页
    backUpActivity() {
      this.$router.push({
        name: 'ActivityDetails',
        query: { id: this.id }
      })
    },
    //报名调取接口
    async submitClick() {
      // this.queryInfo.isSignUp = 1
      console.log(this.queryInfo)
      const { data: res } = await addSignUp(this.queryInfo)
      if (res.resultCode === 200) {
        Toast.success(this.$t('message.activity_upload_works.suc_reg'))
        // this.loginSignUp()
        this.btnShow = true
        this.myselfShow = false
      } else if (res.resultCode === 500) {
        Toast.fail(res.message)
      } else {
        Toast.fail(this.$t('message.activity_upload_works.fail_reg'))
      }
    },
    //点击报名
    signUpClick() {
      if (this.checkedAggesID) {
        this.$refs.form
          .validate()
          .then(() => {
            this.submitClick()
          })
          .catch(() => {
            this.$toast.fail(this.$t('message.activity_upload_works.please_rele'))
          })
      } else {
        this.$toast.fail(this.$t('message.activity_upload_works.please_trueid'))
      }
    },
    //选择赛区
    onConfirm(value) {
      this.queryInfo.competitionArea = value
      this.showPicker = false
    },
    //获取组别
    async getCodeAllZu() {
      const lang = sessionStorage.getItem('lang')
      const { data: res } = await codeList({ code: '004', language: lang })
      if (res.resultCode === 200) {
        this.codeListZu = res.data
      }
    },
    //判断用户是否已本人报名
    async loginSignUp() {
      const query = {
        activityId: this.id,
        worksType: this.index
      }
      const { data: res } = await isSignUp(query)
      if (res.resultCode === 200) {
        if (res.data != null) {
          this.queryInfo = res.data
          console.log(this.queryInfo)
          // this.btnShow = true
          this.myselfShow = true
        } else {
          // this.btnShow = false
          this.myselfShow = false
        }
      }
    },
    //获取赛区
    async getListShow() {
      const { data: res } = await getSaiqu({
        language: sessionStorage.getItem('lang'),
        id: this.id
      })
      if (res.resultCode === 200) {
        if (res.data === null) {
          this.SaiquList = []
        } else {
          this.SaiquList = res.data

          if (this.divisionName) {
            this.queryInfo.competitionArea = this.divisionName
          } else if (sessionStorage.getItem('divisionName')) {
            this.queryInfo.competitionArea = sessionStorage.getItem('divisionName')
          } else {
            this.queryInfo.competitionArea = this.SaiquList[0]
          }
        }
      }
    },
    validate(val) {
      // console.log(val)
      if (!val.phoneNumber) {
        this.empty = true
      } else if (val.phoneNumber) {
        this.empty = false
        this.queryInfo.signUpPhone = val.formattedNumber
      }
      this.validateVal = val
    },
    //活动下面的数据
    async getActivityData() {
      const { data: res } = await getDetailActivity({
        id: this.id,
        language:
          sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang'),
        divisionName: ''
      })
      if (res.resultCode === 200) {
        this.activityData = res.data
      }
    }
  }
}
</script>

<style lang="less" scoped>
.sign_up {
  widows: 100%;
  overflow: hidden;

  .myself {
    widows: 100%;
    overflow: hidden;
    text-align: center;
    color: #1a1a1a;
    font-size: 14px;
    font-weight: 400;
  }

  /deep/ .color_btn {
    color: #fff;
    background-color: #999;
    border: 1px solid #999;
  }

  .dai {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 10px;

    .add_sing_up_btn {
      width: 100%;
      overflow: hidden;

      button {
        width: 100%;
        border-radius: 4px;
      }
    }

    .dai_list {
      width: 100%;
      overflow: hidden;
      margin: 20px 0;

      .dai_list_no {
        width: 100%;
        margin: 40px auto;

        img {
          max-width: 100%;
          max-height: 100%;
          text-align: center;
          margin: 10px auto;
          display: block;
        }

        span {
          color: #999999;
          font-size: 14px;
          font-weight: 400;
          display: block;
          text-align: center;
        }
      }

      .dai_list_ul {
        width: 100%;
        overflow: hidden;

        .dai_list_ul_li {
          width: 100%;
          overflow: hidden;
          margin-bottom: 10px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          box-sizing: border-box;
          padding: 12px;

          .dai_list_ul_li_left {
            flex: 1;

            .dai_list_ul_li_left_title {
              width: 100%;
              overflow: hidden;
              color: #1a1a1a;
              font-size: 16px;
              font-weight: 500;

              span {
                color: #999;
                font-size: 14px;
                font-weight: 400;
              }
            }

            p {
              margin: 6px 0 0 0;
              color: #1a1a1a;
              font-size: 14px;
              font-weight: 400;
            }
          }

          .dai_list_ul_li_right {
            width: 64px;
            margin-left: 12px;

            button {
              width: 64px;
              height: 28px;
              line-height: 28px;
              text-align: center;
              color: #3360ff;
              font-size: 12px;
              border-radius: 16px;
              border: none;
              padding: 0;
            }

            .dai_list_ul_li_right_no {
              background: rgba(153, 153, 153, 0.1);
              color: #263245;
            }
          }
        }
      }
    }

    .dai_back {
      width: 100%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;

      .div_btn_new_btn {
        width: 128px;
        height: 36px;
        font-size: 14px;
        font-weight: 400;
        color: #3562ff;
        border-color: #3562ff;
      }
    }
  }

  .div {
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    padding: 10px 16px;
    background-color: #fff;

    .aggess {
      display: flex;
      align-items: center;
      color: #263245;
      font-size: 12px;
      font-weight: 400;

      span {
        color: #3360ff;
      }
    }
  }

  .form {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;

    .upload_works_flex {
      width: 100%;
      overflow: hidden;

      /deep/ .van-cell {
        display: flex;
        flex-direction: column !important;
        padding: 10px 0;

        .van-cell__title {
          color: #1a1a1a;
          font-size: 14px;
          font-weight: 400;
          margin-bottom: 10px;
        }
      }

      .flex {
        display: flex;
        flex-direction: column;

        .span {
          color: #999999;
          font-size: 10px;
          font-weight: 400;
          line-height: 12px;
        }
      }
    }
  }

  .sign_up_form {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;

    .sign_up_form_title {
      width: 100%;
      box-sizing: border-box;
      padding: 4px;
      border-radius: 4px;
      background-color: #f5f5f5;
      font-size: 11px;
      color: #1a1a1a;

      i {
        color: #92b3e3;
      }
    }

    .sign_up_form_btn {
      width: 100%;
      margin: 12px 0;
      box-sizing: border-box;
      padding: 0 16px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      div {
        width: 146px;
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        text-align: center;
        color: #1a1a1a;
        font-size: 14px;
        font-weight: 400;
        border-radius: 4px;
        border: 1px solid #b0b5c4;
        background: rgba(165, 165, 165, 0.1);
      }

      .active {
        background: rgba(53, 98, 255, 0.1);
        border-color: #3562ff;
      }
    }
  }

  .div_btn {
    width: 100%;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    display: flex;
    padding: 12px;
    margin-top: 14px;
    text-align: center;

    .div_btn_sign_up {
      background: linear-gradient(301.69deg, #6688ff 13.72%, #3360ff 67.35%);
      border-radius: 16px;
      width: 196px;
      height: 36px;
      border: none;
      margin: 0 auto;
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .div_btn_new {
    width: 100%;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 12px 30px;
    margin-top: 14px;

    .div_btn_new_btn {
      width: 100%;
      height: 36px;
      font-size: 14px;
      margin-bottom: 23px;
      font-weight: 400;
    }

    .colorfont {
      color: #3562ff;
      border-color: #3562ff;
    }
  }
  .phoneNumber {
    // width: 345px !important;
    margin: 0 auto;
    flex-direction: row !important;
  }

  .vue-phone-number-input {
    // padding: 0 16px;
    margin: 0;
    /deep/.input-tel__input {
      border: 0;
      border-bottom: 1px solid #ebedf0 !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
    /deep/.country-selector__input {
      border: 0;
      border-bottom: 1px solid #ebedf0 !important;
      border-top-left-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
    }
  }
}
</style>
